/**
 * [MCV-1866] Classes shared by the floating buttons on signed-in pages: Chat Support at the
 * bottom-right and Feedback at the bottom-left. Full literal class strings, so Tailwind's source
 * scan picks up every class.
 */

/**
 * The bottom offset, the same for both so they line up. Both float just above the signed-in
 * SiteFooter, which is always on screen: 97px tall below sm (MCV; HLX's compact footer is 61px),
 * 81px at sm, 57px at md and 45px from lg, so each step leaves a gap of 12px or more above it.
 * [MCV-1957] Below 340px MCV's footer wraps one more line in Inter (117px), so the buttons sit
 * 132px up there. Before this the buttons sat 16px from the bottom and covered the footer's
 * copyright line and legal links. floatingButtons.browser.spec measures it against the real footer.
 */
export const FLOATING_BUTTON_BOTTOM =
  'bottom-28 max-[340px]:bottom-[8.25rem] sm:bottom-24 md:bottom-[4.5rem] lg:bottom-16';

/**
 * Hidden while a modal dialog is open. The buttons are z-30 and FormDialog defaults to z-10, so
 * they would otherwise paint over every dialog and its backdrop, and below sm, where dialogs sit
 * at the bottom of the screen, over the dialog's own buttons. Headless UI's scroll lock writes
 * `overflow: hidden` inline on <html> for every open modal (and nothing else in the app does;
 * MobileMenu locks <body>), so the variant keys off that instead of each dialog's state.
 */
export const HIDE_WHILE_MODAL_OPEN = "[html[style*='overflow:_hidden']_&]:hidden";
